import { useReduxState } from "../../explorer/redux/hooks";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";

export const useApiWarning: () => [string |React.JSX.Element | undefined, (error: string | React.JSX.Element | undefined) => void] = () => {
  const [warning, setWarning] = useReduxState<string | React.JSX.Element | undefined>(reduxStoreConfig.systemApiWarning);
  return [warning, setWarning];
};
